<template>
  <div class="wrap1">
    <h1 class="common-title">
      <span> <i class="el-icon-arrow-left back" @click="handlerBack"></i> {{ $t('certificate_staff_9') }} </span>
    </h1>
    <div class="wrap1-box">
      <div class="search">
        <el-form :model="formData" ref="form" label-position="left" inline>
          <!-- 操作人-->
          <el-form-item :label="$t('922')" prop="value1">
            <staff-search size="small" comment="comment" v-model="formData.operate_id" />
          </el-form-item>
          <!-- 操作时间 -->
          <el-form-item :label="$t('new_operation_time')" prop="value2">
            <el-date-picker
              v-model="operationTime"
              size="small"
              type="daterange"
              format="yyyy-MM-dd"
              valueFormat="yyyy-MM-dd"
              :range-separator="$t('409')"
              :start-placeholder="$t('407')"
              :end-placeholder="$t('408')"
              @change="handlerTime"
            />
          </el-form-item>
          <!-- 修改字段 -->
          <el-form-item :label="$t('i18n.af8408dc529442fbbf219cf54d7ef234')" prop="column">
            <el-select size="small" v-model="formData.column" :placeholder="$t('221')" clearable>
              <el-option v-for="item in options" :key="item.code" :label="item.txt" :value="item.code"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getList(1)">{{ $t('80') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="tableData">
        <el-table-column prop="staff_name" :label="$t('922')" min-width="180"> </el-table-column>
        <el-table-column prop="created_at" :label="$t('new_operation_time')" min-width="180"> </el-table-column>
        <el-table-column prop="column" :label="$t('i18n.af8408dc529442fbbf219cf54d7ef234')" min-width="180">
        </el-table-column>
        <el-table-column prop="before" :label="$t('i18n.96d0184bafc04845830dc9ea577a2712')" min-width="180">
        </el-table-column>
        <el-table-column prop="after" :label="$t('i18n.819922730cb64d049b8d396f211e6613')" min-width="180">
        </el-table-column>
      </el-table>
      <Pagination
        layout="total, sizes, prev, pager, next"
        :page-sizes="[100, 50, 20]"
        :total="formData.total"
        :current-page="formData.page"
        :page-size="formData.page_size"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getPayslipConfigLog, // 获取工资条安全配置修改记录
  payslipConfigInit // 工资条安全配置枚举项
} from '@/api/payroll/pay-slip'
import Pagination from '_c/pagination'
// 员工搜索组件
import StaffSearch from '_c/staff-search'
export default {
  components: { Pagination, StaffSearch },
  data() {
    return {
      operationTime: [],
      options: [],
      formData: {
        operate_id: '',
        column: '',
        start_time: '',
        end_time: '',
        total: 0,
        page: 1,
        page_size: 20
      },
      tableData: []
    }
  },
  created() {
    this.getList(1)
    payslipConfigInit().then(({ data }) => {
      this.options = data.column
    })
  },
  methods: {
    handlerBack() {
      this.$router.push('/payroll/safe-pay-slip')
    },
    getList(page) {
      this.formData.page = page
      getPayslipConfigLog(this.formData).then(({ data }) => {
        this.tableData = data.list
        this.formData.total = data.total
      })
    },
    handlerTime(val) {
      ;[this.formData.start_time, this.formData.end_time] = val || ['', '']
    },
    handleSizeChange(val) {
      this.formData.page_size = val
      this.getList(1)
    },
    handleCurrentChange(val) {
      this.getList(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
